<template>
  <div class="flex flex-col gap-4">
    <template v-if="mode === 'view'">
      <div class="flex gap-8">
        <div>
          <p class="text-muted-foreground text-xs mb-1">Trigger Type</p>
          <p class="font-medium text-sm">{{ selectedInvocation }}</p>
        </div>
        <div v-if="selectedInvocation === 'Scheduled'">
          <p class="text-muted-foreground text-xs mb-1">Days After Trigger</p>
          <p class="font-medium text-sm">{{ delayInDays }}</p>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="flex gap-4">
        <FormKit
          :model-value="selectedInvocation"
          label="Trigger Type"
          name="invocation_type"
          type="select"
          :options="actionInvocationOptions"
          outer-class="!m-0 width-sm"
          @update:model-value="(val?: string) => val && handleInvocationChange(val)"
        />
        <FormKit
          v-if="selectedInvocation === 'Scheduled'"
          :model-value="delayInDays"
          label="Days After Trigger"
          name="delay_in_days"
          type="number"
          :step="0.1"
          :min="0"
          outer-class="!m-0 width-sm"
          @update:model-value="(val?: string) => val && emit('update:delay-in-days', val)"
        />
      </div>
    </template>
  </div>
</template>

<script setup lang="ts">
import { stringToEnum } from '@/lib/typeParser';
import type { ActionItemMode } from './types';
import { actionInvocationOptions, type InvocationOption } from './useActionInvocation';

const handleInvocationChange = (val: string) => {
  const option = stringToEnum(val, actionInvocationOptions);
  if (!option) return;
  emit('update:selected-invocation', option);
};

type ActionInvocationProps = {
  selectedInvocation: InvocationOption;
  delayInDays: string;
  mode: ActionItemMode;
};
const { selectedInvocation } = defineProps<ActionInvocationProps>();

type Emit = {
  'update:selected-invocation': [val: InvocationOption];
  'update:delay-in-days': [val: string];
};
const emit = defineEmits<Emit>();
</script>

<style scoped>
.width-sm {
  @apply w-[14rem] max-w-[14rem];
}
</style>
